define('module/AdaCompliantModule',['require','marionette','model/AdaCompliantModuleModel','view/module/AdaCompliantView','lib/plugin/PluginBroker','lib/WindowMessageListener','Config'],function (require) {

    var Marionette = require('marionette');
    var AdaCompliantModuleModel = require('model/AdaCompliantModuleModel');
    var AdaCompliantView = require('view/module/AdaCompliantView');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var WindowMessageListener = require('lib/WindowMessageListener');

    var Config = require('Config');
    /**
     * Controller for reviews module
     *
     * @class ReviewModule
     */
    return Marionette.Object.extend({

        _regions: {
            adacomp: '#sb_ada_module'
        },
        _model: null,
        _layout: null,
        _view: null,
        _clientModel: null,

        /**
         * Inits instance
         */
        initialize: function () {
            this._layout = this.getOption('layout');
            //var config = Config.getInstance();
            //console.log(config, config.getOption('allow_switch_to_ada'));

            this._model = AdaCompliantModuleModel.getInstance();

            Backbone.Wreqr.radio.channel('page').vent.on(
                'shown', _.bind(this._initView, this)
            );
        },

        /**
         * Initializes regions and views
         *
         * @private
         */
        _initView: function () {
            _.each(this._regions, function (selector, region) {
                this._layout.addRegion(region, selector);
            }, this);

            //if (!Config.getInstance().getPluginStatus('client_login')) {
                if (this._layout.adacomp && this._layout.adacomp.$el.length) {
                    if (!this._view || this._view.isDestroyed) {
                        this._view = this._getADASwitcherView();
                        this._layout.adacomp.show(this._view);
                    }
                }
            //}
        },

        _getADASwitcherView: function () {
            return new AdaCompliantView({
                model: this._model
            });
        },


    });

});
